import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const AdminProtectedRoute = ({ children }) => {
    const isLoggedIn = localStorage.getItem('adminid') 
    // && localStorage.getItem('token');
    const navigate = useNavigate();

    console.log(isLoggedIn)
  
    useEffect(() => {
      if (!isLoggedIn) {
        // Redirect to login page if not logged in
        navigate('/site/adminlogin');
      }
    }, [isLoggedIn, navigate]);
  
    return isLoggedIn ? children : null;
};
